/**
 * @file        src/pages/flight/UsedCoupons.jsx
 * @description Used Coupon List (read-only): bookings that applied a coupon.
 * @author      Kinetika Labs
 * @created     2026-07-01
 * @changelog
 *   - 2026-07-01 Claude — Initial (B2C Flight Management).
 *   - 2026-08-10 Claude — Added title/subtitle/audience props (defaulting to the
 *                          unchanged B2C behaviour) so CorporateUsedCoupons.jsx
 *                          can reuse this page fixed to audience=b2b instead of
 *                          forking it — the backend now actually applies
 *                          `audience` (it previously accepted but ignored it).
 */
import ReadOnlyListPage, { fmtDate } from './ReadOnlyListPage';
import { money, idCell, customerCell } from './cells';

export default function UsedCoupons({
  title = 'Used Coupon List',
  subtitle = 'B2C Flight · coupons applied on bookings',
  audience = 'b2c',
} = {}) {
  return (
    <ReadOnlyListPage
      title={title}
      subtitle={subtitle}
      endpoint="/flight/used-coupons"
      queryRoot={`flight-used-coupons-${audience}`}
      extraParams={{ audience }}
      searchLabel="Coupon code"
      columns={[
        { key: 'id', label: 'Booking ID', render: idCell },
        { key: 'coupon_code', label: 'Coupon', render: (v) => <b>{v}</b> },
        { key: 'coupon_discount', label: 'Discount', render: money },
        { key: 'customer_name', label: 'Customer', render: customerCell },
        { key: 'booking_reference', label: 'Booking Ref', render: (v) => <span className="mono">{v || '—'}</span> },
        { key: 'total_paid', label: 'Total Paid', render: money },
        { key: 'created_at', label: 'Used On', render: fmtDate },
      ]}
    />
  );
}
